/**
 * Adapter para la API de reportes de logística
 * Adapter for logistics reports API
 */

import { HttpClient } from '@adapters/HttpClient';
import { LogisticsApiResponse } from '../models/LogisticsApiResponse';
import { LogisticsFilters } from '../models/LogisticsFilters';

export class LogisticsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Obtiene los datos del reporte de logística
   * Gets logistics report data
   */
  async getLogisticsReport(filters?: LogisticsFilters): Promise<LogisticsApiResponse> {
    // Construir parámetros de query
    // Build query parameters
    const params: Record<string, any> = {};

    if (filters) {
      if (filters.team_id !== undefined) {
        params.team_id = filters.team_id;
      }
      if (filters.start_date) {
        params.start_date = filters.start_date;
      }
      if (filters.end_date) {
        params.end_date = filters.end_date;
      }
      if (filters.date_column) {
        params.date_column = filters.date_column;
      }
      if (filters.payment_method_id !== undefined && filters.payment_method_id !== null) {
        params.payment_method_id = filters.payment_method_id;
      }
      if (filters.shop_id !== undefined && filters.shop_id !== null) {
        params.shop_id = filters.shop_id;
      }
      if (filters.courier_id !== undefined && filters.courier_id !== null) {
        params.courier_id = filters.courier_id;
      }
      if (filters.search) {
        params.search = filters.search;
      }
    }

    const response = await this.httpClient.get<LogisticsApiResponse>(
      '/report/logistic',
      params
    );

    return response;
  }
}

